import React from 'react'
import { Modal } from 'antd'
import { createPortal } from 'react-dom'

import agaPopupIcon from 'src/assets/icons/sheep.jpeg'
import { ModalStyle, TopIcon } from './ModalStyle'
import { useAppSelector } from 'src/store'

const UploadProgressModal: React.FC = () => {
  const { visible, status, uploaded, total } = useAppSelector(
    (state) => state.ui.uploadProgress,
  )
  const portalDiv = document.getElementById('root')

  if (!visible || !portalDiv) return null

  return createPortal(
    <Modal
      open={visible}
      centered
      closable={false}
      maskClosable={false}
      footer={null}
      className="basic-modal modal-confirm-btn"
    >
      <ModalStyle>
        <div className="d-flex justify-content-center">
          <TopIcon>
            <img className="img" src={agaPopupIcon} alt="" />
          </TopIcon>
        </div>
        <div className="modal-content styleCustomModal">
          <div className="modal-body">
            {status === 'uploading' ? (
              <p>
                画像アップロード中: {uploaded}/{total}
              </p>
            ) : (
              <>
                <p>アップロードが完了しました</p>
                <p>本人確認完了画面へ移動します</p>
              </>
            )}
          </div>
        </div>
      </ModalStyle>
    </Modal>,
    portalDiv,
  )
}

export default UploadProgressModal
